var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section main-section--platform"
  }, [_c('div', {
    staticClass: "ct"
  }, [_vm._m(0), _c('ul', {
    staticClass: "platform"
  }, _vm._l(_vm.platforms, function (platform) {
    return _c('li', {
      key: platform.subtit,
      staticClass: "platform__list"
    }, [_c('div', {
      staticClass: "platform__box"
    }, [_c('div', {
      staticClass: "platform__icon"
    }, [_c('img', {
      attrs: {
        "src": platform.icon,
        "alt": ""
      }
    })]), _c('p', {
      staticClass: "subtit"
    }, [_vm._v(_vm._s(platform.subtit))]), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(platform.txt))]), _c('a', {
      staticClass: "btn",
      attrs: {
        "href": platform.link
      }
    }, [_vm._v("자세히 보기")])])]);
  }), 0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h3', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("플랫폼 이용 방법")])]);
}]

export { render, staticRenderFns }